// Dawn's own dropdown/mega-menu (<header-menu> wrapping a <details>) only
// opens on click. This adds hover-to-open for desktop (devices whose
// primary input can actually hover — matching the (hover: hover) checks
// used elsewhere in this theme), while leaving click/keyboard behavior
// exactly as Dawn built it (native <details>/<summary>, still fully
// usable via click or Enter/Space on a keyboard, and touch devices are
// untouched since this only runs where hover is real).
//
// Setting/clearing the <details> "open" property (rather than adding new
// CSS) reuses the theme's existing open-state styling and the toggle
// event assets/details-disclosure.js already listens for, so nothing
// else needs to know this was opened by hover instead of a click.
//
// The dropdown's white panel stays full page-width (Dawn's own layout,
// untouched), but the list of links inside it is pushed right with an
// inline padding-left so the text starts under the trigger word's own
// position instead of the page's left margin — the panel's width isn't
// tied to any one trigger, so this offset has to be measured per-open
// rather than expressed as a fixed value in CSS.
if (window.matchMedia('(hover: hover)').matches) {
  // Moving straight from one top-left item to another (SHOP -> TEAM P3 ->
  // ABOUT P3): the open dropdown closes at once and the new one takes its
  // place without unfolding again — the white panel stays put and only
  // its links fade in (.p3-dd-switch, "Desktop dropdowns: smooth switching"
  // in assets/custom-styles.css). Only the first one unfolds from the bar.
  var menus = [];

  document.querySelectorAll('.header__inline-menu > .list-menu--inline > li > header-menu').forEach(function (menu) {
    var details = menu.querySelector(':scope > details');
    if (!details) return;
    var summary = details.querySelector(':scope > summary');
    var list = details.querySelector(':scope > .mega-menu__content > .mega-menu__list');
    var closeTimer = null;

    function alignList() {
      if (!list || !summary) return;
      var content = details.querySelector(':scope > .mega-menu__content');
      var label = summary.querySelector('span') || summary;
      var labelLeft = label.getBoundingClientRect().left;
      var contentLeft = content ? content.getBoundingClientRect().left : 0;
      list.style.paddingLeft = Math.max(0, labelLeft - contentLeft) + 'px';
    }

    var content = details.querySelector(':scope > .mega-menu__content');

    function closeNow() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      details.open = false;
      if (summary) summary.setAttribute('aria-expanded', 'false');
      if (content) content.classList.remove('p3-dd-switch');
    }

    function open() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (!details.open) {
        // another dropdown still showing: close it now, and switch over
        var switching = false;
        menus.forEach(function (other) {
          if (other.details !== details && other.details.open) {
            other.closeNow();
            switching = true;
          }
        });
        if (content) content.classList.toggle('p3-dd-switch', switching);
        details.open = true;
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
      alignList();
    }

    function scheduleClose() {
      closeTimer = setTimeout(closeNow, 150); // short delay so moving the cursor from the summary down into the panel doesn't flicker-close it
    }

    menus.push({ details: details, closeNow: closeNow });

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', scheduleClose);
    menu.addEventListener('focusin', open);
  });

  // SHOP / TEAM P3 / ABOUT P3 have different numbers of sub-links, so
  // left to their natural (content-driven) height the white dropdown
  // panel's bottom edge would jump up or down depending on which one's
  // open. Measure every panel's real height once up front (each is
  // static content, so this only needs to run once) and floor every
  // panel to the tallest one, so the bottom edge stays put no matter
  // which parent is hovered. Measuring is done with visibility:hidden
  // rather than moving/resizing the panel, so it briefly renders at its
  // real full-width layout off-screen-invisibly instead of a
  // shrink-to-fit width that could measure the wrong (wrapped) height.
  var panels = document.querySelectorAll('.header__inline-menu .mega-menu__content');
  var maxHeight = 0;
  panels.forEach(function (panel) {
    var details = panel.closest('details');
    if (!details) return;
    var wasOpen = details.open;
    panel.style.visibility = 'hidden';
    details.open = true;
    maxHeight = Math.max(maxHeight, panel.scrollHeight);
    details.open = wasOpen;
    panel.style.visibility = '';
  });
  if (maxHeight > 0) {
    panels.forEach(function (panel) {
      panel.style.minHeight = maxHeight + 'px';
    });
  }
}
